import { buildMixpanelTracker } from './mixpanel';

export const Tracker = buildMixpanelTracker();
